import React from "react";

export default function P_Solicitatieavond() {
    window.location.href = "https://forms.gle/o1wqvHdojE5G5qQR8";
}
